
import { defineComponent, onMounted, onUnmounted, watch } from 'vue'
import useSettingModal from '@web/composition/useSettingModal'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: () => true
    },
    options: {
      type: Array as () => (CourseOptions & { value: TrainingLessonOptionValue})[],
      required: true
    },
    streamId: {
      type: Number,
      required: true
    },
    filters: {
      type: Object as () => LessonFilters,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup (props, ctx) {
    const data = useSettingModal({
      streamId: props.streamId
    })

    onMounted(() => {
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          close()
        }
      })
    })

    onUnmounted(() => {
      document.body.style.overflowY = 'scroll'
    })

    watch(() => props.modelValue, (val) => {
      if (val) {
        document.body.style.overflowY = 'hidden'
      } else {
        document.body.style.overflowY = 'scroll'
      }
    })

    function close () {
      ctx.emit('update:modelValue', false)
    }

    return {
      ...data,
      close
    }
  }
})
